var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalicbutton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27.001,
    viewBox: "0 0 27 27.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_69",
    "data-name": "Union 69",
    d: "M7207.633-6070a5.652,5.652,0,0,1-5.631-5.66v-15.682a5.651,5.651,0,0,1,5.631-5.659h15.737a5.652,5.652,0,0,1,5.631,5.659v15.682a5.653,5.653,0,0,1-5.631,5.66Zm-3.568-21.342v15.682a3.58,3.58,0,0,0,3.568,3.587h15.737a3.583,3.583,0,0,0,3.569-3.587v-15.682a3.583,3.583,0,0,0-3.569-3.587h-15.737A3.58,3.58,0,0,0,7204.064-6091.343Zm9.931,14.708h-3.141a1.033,1.033,0,0,1-1.029-1.036,1.032,1.032,0,0,1,1.029-1.036h2.335l2.487-9.586h-1.794a1.035,1.035,0,0,1-1.032-1.038,1.035,1.035,0,0,1,1.032-1.036h6.259a1.033,1.033,0,0,1,1.032,1.036,1.034,1.034,0,0,1-1.032,1.038h-2.331l-2.491,9.586h1.8a1.034,1.034,0,0,1,1.031,1.036,1.035,1.035,0,0,1-1.031,1.036Z",
    transform: "translate(-7202.001 6097.002)",
    fill: "#fff",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalicbutton);
export default __webpack_public_path__ + "static/media/italicbutton.5f4c25d26de6a2213c47960fa828fb40.svg";
export { ForwardRef as ReactComponent };